<template>
  <v-container
    fluid
    class="fill-height"
  >
    <!-- QUICK ACCESS BUTTONS -->
    <v-row
      v-if="catalog.imported"
      class="flex-grow-1 align-self-start"
    >
      <v-col class="d-flex flex-column align-end">
        <v-btn
          v-for="item in entries"
          :key="item.code"
          text
          dense
          :color="getEntryStyle(item.type).color"
          outlined
          class="pa-1 ma-1"
          @click="$emit('quick:select', item)"
        >
          {{ item.code }}<v-icon right>
            mdi-chevron-double-right
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Catalog from '@/models/catalog'
import { getEntryStyle } from '@/components/utils'

export default {
  name: 'QuickLaunch',

  props: {
    catalog: {
      type: Catalog,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    entries: function() {
      // just the catalog entries with a code
      if (!this.catalog.imported) return []
      return this.catalog.entries.filter(e => e.code.length > 0)
    },
  },
  methods: {
    getEntryStyle,
  },
}
</script>

<style lang="scss"></style>
